import { createTheme } from '@mui/material/styles'

export const getTheme = (direction = 'rtl', language = 'ar') => {
  const isArabic = language.startsWith('ar')

  return createTheme({
    direction,
    palette: {
      mode: 'dark',
      background: { default: '#2B2B2B', paper: '#2B2B2B' },
      primary: { main: '#7A2E3A' },
      secondary: { main: '#D9D6CF' },
      text: { primary: '#D9D6CF', secondary: 'rgba(217,214,207,0.65)' },
    },
    typography: {
      fontFamily: isArabic ? "'IBM Plex Sans Arabic', sans-serif" : "'Manrope', sans-serif",
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 999, textTransform: 'none', boxShadow: 'none' },
        },
      },
    },
  })
}